import React from "react";
import { Box, Grid, Typography, Stack, Button } from "@mui/material";
import Image22 from "../images/Image-25.webp";
import { motion } from "framer-motion";
import '../css/ReferAndEarn.css';
import { fadeInLeft } from "../animations/motionConfigs";
import ReferralPopUp from "../../components/ReferralPopUp";
import ReferralPopUpV2 from "./Popup/ReferralPopUpV2";

export default function ReferAndEarn(props) {
    const { isSmallScreen, city } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <Box
            sx={{
                maxWidth: isSmallScreen ? "90%" : "70%",
                mx: "auto",
                mt: isSmallScreen ? 0 : 8,
                mb: isSmallScreen ? 2 : 8,
                position: "relative",
            }}
        >
            <Grid
                container
                sx={{
                    bgcolor: "#fff",
                    borderRadius: "20px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    overflow: "visible",
                    alignItems: "stretch",
                    p: { xs: 3, md: 6 },
                    position: "relative",
                    bgcolor: "black",
                }}
            >
                <Grid item xs={12} md={7}>
                    <motion.div {...fadeInLeft} >
                        <Typography
                            variant={isSmallScreen ? 'h5' : "h4"}
                            sx={{
                                fontWeight: 700,
                                mb: 3,
                                fontFamily: "Poppins, sans-serif",
                                color: "#B255FF",
                            }}
                        >
                            Refer & Earn Up to ₹20,000!
                        </Typography>
                    </motion.div>
                    <motion.div {...fadeInLeft} style={{ color: "white", fontSize: "16px", lineHeight: 1.5, }}>
                        Know someone who’s ready to upgrade their career with the best DevOps training {city && `in ${city}`}?
                    </motion.div>

                    <motion.div {...fadeInLeft} style={{ color: "white", fontSize: "16px", lineHeight: 1.5, display: !isSmallScreen && "flex", alignItems: "flex-end", gap: "8px" }}>
                        Refer a friend to PaperLive and earn <p style={{ fontSize: "30px", fontWeight: "700" }}>₹20,000</p>
                    </motion.div>
                    <motion.div {...fadeInLeft} style={{ color: "white", fontSize: "16px", lineHeight: 1.5, }}>
                        for every successful enrolment.
                    </motion.div>
                    <motion.div {...fadeInLeft} style={{ color: "white", fontSize: "16px", lineHeight: 1.5, }}>
                        Because great opportunities are even better when shared.
                    </motion.div>

                    <motion.div {...fadeInLeft}>
                        <Button
                            aria-label="Refer and Earn Button"
                            variant="contained"
                            onClick={() => setOpen(true)}
                            sx={{
                                bgcolor: "#DAADFF",
                                color: "black",
                                margin: "2rem auto",
                                py: 1,
                                fontWeight: 600,
                                fontSize: "22px",
                                textTransform: "none",
                                borderRadius: "20px",
                                "&:hover": {
                                    opacity: 0.9,
                                    bgcolor: "#B255FF",
                                },
                                width: isSmallScreen ? "100%" : "auto"
                            }}>
                            {
                                isSmallScreen ? "Refer Now" : "Start Referring & Start Earning Today!"
                            }
                        </Button>
                    </motion.div>

                </Grid>

                {/* Right side - Image */}
                {!isSmallScreen && <Grid
                    item
                    xs={12}
                    md={5}
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end", // Stick image to bottom
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: "-55px",
                            right: "-120px",
                        }}
                    >
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5 }}
                        >
                            <img
                                loading="lazy"
                                src={Image22}
                                alt="Bootcamp Student"
                                style={{
                                    width: "400px",
                                    height: "auto",
                                    borderRadius: "20px",
                                }}
                            />
                        </motion.div>
                    </Box>
                </Grid>}
            </Grid>
            {open &&
                <ReferralPopUpV2 setOpen={setOpen} open={open} isSmallScreen={isSmallScreen} refer={true} />
            }
        </Box>
    );
}
